import Vuelidate from 'vuelidate'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
import * as ModalDialogs from 'vue-modal-dialogs'
import VueClipboard from 'vue-clipboard2'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import { get } from 'lodash/object'

import { router } from './router'
import { registerError404 } from './helpers'
import * as components from './components'
import * as mixins from './mixins'
import Argon from './app'
import { installVuetify } from './vuetify'
import { axios } from './axios'

const appName = 'app'

const VuePlugin = {
  install: (Vue, options) => {
    // install app
    const appOpts = get(options, 'appOpts', {})
    const app = new Argon(appOpts)
    Object.defineProperty(Vue.prototype, `$${appName}`, {
      get() {
        return app
      }
    })
    registerError404(router)
    // install vuelidate
    Vue.use(Vuelidate)
    // install croppa
    Vue.use(Croppa)
    // install clipboard
    Vue.use(VueClipboard)
    // install modal-dialogs
    Vue.use(ModalDialogs)
    Vue.use(PerfectScrollbar)

    // install axios
    Vue.prototype.$axios = axios
  }
}

export default VuePlugin
export { components, mixins, installVuetify }
